// import axios from 'axios';

// export const fetchProducts = async () => {
//   const response = await axios.get('https://api.cannamart.ca/mock/product');
//   return response.data;
// };

import { Api } from '../Config/request';

export const getProducts = async (params) => {
  const response = await Api.GetRequest("/product", params);
  return response;
};


export const addNewProduct = async (data) => {
  const response = await Api.PostRequest("/product", data);
  return response;
};

export const getProductById = async (data) => {
  const response = await Api.GetRequest(`/product/${data.id}`);
  return response;
};

export const updateProduct = async ({data }) => {
  const response = await Api.PutRequest(`/product/${data.id}`, data);
  return response;
};

export const deleteProduct = async (data) => {
  const response = await Api.DeleteRequest(`/product/${data.id}`, data);
  return response;
};

export const searchProducts = async (params) => {
  const response = await Api.GetRequest("/product", params);
  return response;
};

//todo: %3APO is the mock API part, might be replaced later
export const getPurchaseOrder = async () => {
  const response = await Api.GetRequest(
    "purchaseOrder?q=order_number%3APO&expandOrganisation=true&expandProduct=true"
  );
  return response;
};

export const deletePurchaseOrder = async (id) => {
  const response = await Api.DeleteRequest(`/purchaseOrder/${id}`);
  return response;
};

export const getPurchaseOrderById = async (id) => {
  const response = await Api.GetRequest(`/purchaseOrder/${id}`);
  return response;
};

export const updatePurchaseOrder = async ({ id, data }) => {
  const response = await Api.PutRequest(`/purchaseOrder/${id}`, data);
  return response;
};

export const createPurchaseOrder = async (data) => {
  const response = await Api.PostRequest("/purchaseOrder", data);
  return response;
};

const productApi={deleteProduct,updateProduct,getProductById,addNewProduct,getProducts, searchProducts, getPurchaseOrder, deletePurchaseOrder, getPurchaseOrderById, updatePurchaseOrder, createPurchaseOrder}

export default productApi;
